import { Driver } from './driver';
import { autoserialize, autoserializeAs } from 'cerialize';
import { AbstractLinkModel } from '@uzurv/core';

export class IgnoredDriver extends AbstractLinkModel {
  @autoserialize
  riderId: number;

  @autoserializeAs(Driver)
  driver: Driver;
}
